import React, { useEffect } from 'react'
import clsx from 'clsx'
import { Button, Grid, Icon } from 'gu-ui-kit'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import styles from 'modules/Services/AccountCreate/subcomponents/SidePanel/SidePanel.module.scss'
import PropTypes from 'prop-types'
import { LogoIcon } from 'layouts/subcomponents/Logo'

const SidePanel = ({ shown = false, children = null, onClose = () => {} }) => {
  const breakpoints = useBreakpoint()

  useEffect(() => {
    document.body.style.overflow = shown ? 'hidden' : 'visible'
  }, [shown])

  return (
    <div
      className={clsx(styles['side-panel'], {
        [styles['side-panel_open']]: shown,
      })}
    >
      <div
        className={clsx(styles['side-panel__overlay'], {
          [styles['side-panel__overlay_open']]: shown,
        })}
        onClick={onClose}
      />
      <div
        className={clsx(styles['side-panel__container'], {
          [styles['side-panel__container_open']]: shown,
        })}
      >
        <Grid
          className={styles['side-panel__header']}
          alignItems={'center'}
          justifyContent={'between'}
        >
          {!breakpoints.fb ? <LogoIcon size={'compact'} /> : <div />}
          <Button
            onClick={onClose}
            noLabel
            variant={'ghost'}
            grey
            size={breakpoints.xs ? 's' : 'm'}
            startIcon={<Icon name={'close'} />}
          />
        </Grid>

        <div className={styles['side-panel__content']}>{children}</div>
      </div>
    </div>
  )
}

export default SidePanel

SidePanel.propTypes = {
  shown: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
}
